import styled from 'styled-components';
import { motion, Variants } from 'motion/react';
import { space, SpaceProps, color, ColorProps, border, BorderProps, layout, LayoutProps } from 'styled-system';
import type { ComponentProps } from 'react';
import Box from '../box/box';

interface CollapseProps extends SpaceProps, ColorProps, BorderProps, LayoutProps {}

const variants: Variants = {
	hidden: { opacity: 0, y: '-10px', transitionEnd: { display: 'none' } },
	visible: { opacity: 1, y: 0, scale: 1, display: 'block' }
};

const variantsRotate: Variants = {
	down: { rotate: '0deg', y: ['0px', '-2px', '2px', '0px'] },
	up: { rotate: '180deg', y: ['0px', '2px', '-2px', '0px'] }
};

// interface ExtendedSpaceProps extends SpaceProps {
// 	backgroundColor: string;
// }

const WrapperStyled = styled.div<CollapseProps>`
	position: relative;
	.icon--sprite {
		fill: var(--collapse-view-chevron, currentColor);
	}
	${space}
	${color}
	${border}
	${layout}
`;

const Wrapper = ({
	p = 6,
	mt = 0,
	mb = 2,
	bg = 'var(--link-list, rgba(var(--base-10), 1))',
	borderRadius = '3px',
	...rest
}: ComponentProps<typeof WrapperStyled>) => (
	<WrapperStyled p={p} mt={mt} mb={mb} bg={bg} borderRadius={borderRadius} {...rest} />
);

const MotionIconWrapper = styled(motion.span)<{ height?: number; width?: number }>`
	height: ${({ height }) => `${height || 24}px`};
	width: ${({ width }) => `${width || 24}px`};
`;

const Flex = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	cursor: pointer;
`;

const MotionBox = motion.create(Box);

const ContentWrapper = ({
	bg = 'var(--link-list, rgba(var(--base-10), 1))',
	...rest
}: ComponentProps<typeof MotionBox>) => <MotionBox bg={bg} {...rest} />;

export { variants, variantsRotate, Wrapper, MotionIconWrapper, Flex, ContentWrapper };
